import { render, staticRenderFns } from "./LegalPrompt.vue?vue&type=template&id=112262c4&"
import script from "./LegalPrompt.vue?vue&type=script&lang=js&"
export * from "./LegalPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports